"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _timePicker = _interopRequireDefault(require("@amzn/meridian-tokens/component/time-picker"));

var _optionList = _interopRequireWildcard(require("../_option-list"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _text = _interopRequireDefault(require("./../_styles/text"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var wrapperStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var minWidth = _ref.minWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    boxSizing: "border-box",
    minWidth: minWidth,
    overflowY: "auto",
    display: "flex",
    flexDirection: "row",
    padding: "0 ".concat(t("optionsSpacingHorizontal"), "px"),
    "& > [role=listbox]": {
      flex: 1,
      overflowY: "auto",
      padding: "0 ".concat(t("optionsSpacingHorizontal"), "px")
    },
    "& [role=option]": {
      margin: "".concat(t("optionsSpacingVertical"), "px 0"),
      borderRadius: t("optionsBorderRadius"),
      textAlign: "center"
    }
  });
}, ["minWidth"]); // The option you know and love, but only shows preselected stylings on focus.

var OptionListPreselectedFocus = function OptionListPreselectedFocus(props) {
  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      preselectedIndex = _useState2[0],
      setPreselectedIndex = _useState2[1];

  var lastIndex = (0, _react.useRef)(0);
  var onBlur = (0, _react.useCallback)(function () {
    return setPreselectedIndex(null);
  }, []);
  var onFocus = (0, _react.useCallback)(function () {
    return setPreselectedIndex(lastIndex.current || 0);
  }, []);
  var onChangePreselectedIndex = (0, _react.useCallback)(function (index) {
    setPreselectedIndex(index);
    lastIndex.current = index;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_optionList["default"], (0, _extends2["default"])({}, props, {
    onBlur: onBlur,
    onFocus: onFocus,
    preselectedIndex: preselectedIndex,
    onChangePreselectedIndex: onChangePreselectedIndex
  }));
};

var TimePickerOptions = function TimePickerOptions(props) {
  var options = props.options,
      values = props.values,
      onSelectOption = props.onSelectOption;
  var t = (0, _theme.useTheme)(_timePicker["default"], "timePicker");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperStyles(t, props)
  }, options.map(function (_ref2) {
    var options = _ref2.options,
        type = _ref2.type;
    var selectedValue = values[type];
    return /*#__PURE__*/_react["default"].createElement(OptionListPreselectedFocus, {
      key: type
    }, options.map(function (value, index) {
      return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListItem, {
        key: index,
        selected: value === selectedValue,
        label: value,
        onClick: function onClick() {
          return onSelectOption(type, value);
        }
      });
    }));
  }));
};

TimePickerOptions.displayName = "TimePickerOptions";
TimePickerOptions.propTypes = process.env.NODE_ENV !== "production" ? {
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
  })),
  values: _propTypes["default"].object,
  onSelectOption: _propTypes["default"].func
} : {};
TimePickerOptions.defaultProps = {};
var _default = TimePickerOptions;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/time-picker/time-picker-options.js
// module id = 892
// module chunks = 0